import { Controller } from "@hotwired/stimulus"
import { loadStripe } from "@stripe/stripe-js"

export default class extends Controller {
  static targets = ["error", "submit"]
  static values = {
    clientSecret: String,
    completeUrl: String,
    publicKey: String
  }

  async submit() {
    this.setBusy(true)
    this.errorTarget.textContent = ""

    const stripe = await loadStripe(this.publicKeyValue)
    const { error } = await stripe.handleNextAction({ clientSecret: this.clientSecretValue })

    if (error) {
      this.errorTarget.textContent = error.message
      this.setBusy(false)
      return
    }

    window.location.assign(this.completeUrlValue)
  }

  setBusy(busy) {
    this.submitTarget.disabled = busy
    this.submitTarget.textContent = busy ? "Confirming..." : "Confirm payment"
  }
}
